import React from 'react'
import PropTypes from 'prop-types'
import { Message } from 'mage-i18n'

import { IconNotification, ParagraphSecondary, constants } from 'mage-deps/@klarna/bubble-ui'

const { Colors, Grid } = constants
const GRID_SIZE = Grid.SIZE
const styleSheet = {
  base: {
    position: 'relative',
    top: -(GRID_SIZE - 1),
    backgroundColor: Colors.SECONDARY
  },
  ribbon: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    paddingTop: GRID_SIZE * 2,
    paddingRight: GRID_SIZE * 6,
    paddingBottom: GRID_SIZE * 2,
    paddingLeft: GRID_SIZE * 6
  },
  message: {
    marginLeft: GRID_SIZE * 2
  }
}

const NotificationBanner = (
  {
    tFallback,
    Icon = <IconNotification color='white' />,
    tPath = '',
    backgroundColor = Colors.SECONDARY,
    textColor = Colors.white
  }) => {
  styleSheet.base.backgroundColor = backgroundColor
  styleSheet.base.color = textColor
  return (
    <div style={{ backgroundColor, ...styleSheet.base }}>
      <div style={styleSheet.ribbon}>
        {Icon}
        <div style={styleSheet.message}>
          <ParagraphSecondary white>
            <Message path={tPath} fallback={tFallback} />
          </ParagraphSecondary>
        </div>
      </div>
    </div>
  )
}

NotificationBanner.propTypes = {
  tFallback: PropTypes.string.isRequired,
  Icon: PropTypes.node,
  tPath: PropTypes.string,
  backgroundColor: PropTypes.object,
  textColor: PropTypes.object
}

export default NotificationBanner
